import apiUtils from '@elab/core/utils/apiUtils';

import HTTPClient from '../../utils/HTTPClient';
import cartApi from '../cart/api';

const getApiService = apiUtils.getBaseUri;

const getDeliveryMode = async (userId, cartId) => {
    const uri = `${cartApi.getCurrentCartApiService(userId, cartId)}/deliverymode`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(
            `Unable to get ... store/checkout/api.js --> getDeliveryMode(): (${response})`,
        );
    }
    return await response.json();
};

const getDeliveryTimeSlots = async (deliveryMode, postalCode, houseNumber) => {
    const uri = `${getApiService()}/deliverymodes/${deliveryMode}/deliveryslots/${postalCode}${
        houseNumber ? `?houseNumber=${houseNumber}` : ''
    }`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        const { errors = [] } = await response.json();
        if (errors[0] && errors[0].type === 'UnsupportedDeliveryAddressError') {
            throw new Error(`${errors[0].message}`);
        } else {
            throw new Error(`Unable to get delivery time options (${response.status})`);
        }
    }
    return await response.json();
};

const getDeliveryModes = async (userId, cartId) => {
    const uri = `${cartApi.getCurrentCartApiService(userId, cartId)}/deliverymodes`;
    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw new Error(`Unable to get delivery modes (${response.status})`);
    }
    return await response.json();
};

const setDeliveryAddress = async (userId, cartId, addressDto) => {
    const uri = `${cartApi.getCurrentCartApiService(userId, cartId)}/addresses/delivery`;
    const response = await HTTPClient().postJson(uri, addressDto);

    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
};

const putDeliveryAddress = async (userId, cartId, addressId) => {
    const uri = `${cartApi.getCurrentCartApiService(
        userId,
        cartId,
    )}/addresses/delivery?addressId=${addressId}`;

    const response = await HTTPClient().putJson(uri);
    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
};

const deleteDeliveryAddress = async (userId, cartId) => {
    const uri = `${cartApi.getCurrentCartApiService(userId, cartId)}/addresses/delivery`;

    const response = await HTTPClient().delete(uri);

    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
};

const setDeliveryMode = async (userId, cartId, deliveryModeId, selectedStore, deliveryTime) => {
    let uri = `${cartApi.getCurrentCartApiService(
        userId,
        cartId,
    )}/deliverymode?deliveryModeId=${deliveryModeId}`;
    if (deliveryModeId.toLowerCase() === 'pickup') {
        uri = uri.concat(`&storeId=${selectedStore}`);
    }
    if (deliveryTime) {
        uri = uri.concat(`&deliverySlot=${deliveryTime}`);
    }
    const response = await HTTPClient().putJson(uri);
    if (!response.ok) {
        throw new Error(`Unable to set email (${response.status})`);
    }
    return response;
};

export default {
    getDeliveryMode,
    getDeliveryTimeSlots,
    getDeliveryModes,
    setDeliveryAddress,
    putDeliveryAddress,
    deleteDeliveryAddress,
    setDeliveryMode,
};
